module.exports = __webpack_public_path__ + "media/assets/images/layout/icon-left-right-d1c99b5b8103845daa1c8875e6d2da97.png";